module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "progress-box"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    class: [_vm.setType, _vm.striped && 'progress-bar-striped', _vm.animate && 'active'],
    style: ({
      width: _vm.state + '%'
    })
  }, [(!_vm.end) ? _c('span', [_vm._v(_vm._s(_vm.state + "%"))]) : _vm._e()])]), _vm._v(" "), (!!_vm.end) ? _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.state + "%"))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-96fbe3a6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/progress.vue
// module id = 331
// module chunks = 2